import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid, Stack, useMediaQuery } from "@mui/material";
import { IndianCurrency } from "app/utils/helper";
import { FeeStructureTableWrapper } from "../style";
const ShowFeeStructure = ({ feeData }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [state, setState] = useState({
    totalFee: 0,
    totalDiscount: 0,
    totalFinalFee: 0,
  });
  useEffect(() => {
    if (feeData?.list?.length > 0) {
      let totalFee = 0;
      let totalDiscount = 0;
      let totalFinalFee = 0;
      feeData?.list?.forEach((item) => {
        totalFee =
          totalFee +
          Number(item?.generalFeeAmount ?? 0) * Number(item?.count ?? 0);
        totalDiscount =
          totalDiscount +
          Number(item?.categoryDiscountAmount ?? 0) * Number(item?.count ?? 0);
        totalFinalFee =
          totalFinalFee +
          Number(item?.feeAmount ?? 0) * Number(item?.count ?? 0);
      });

      setState({
        totalFee,
        totalDiscount,
        totalFinalFee,
      });
    }
  }, [feeData]);

  return (
    <>
      <FeeStructureTableWrapper>
        {!isMobile && (
          <Grid container className="inner_box__head">
            <Grid item xs={3}>
              <Typography className="inner_box_head_title">Fee Type</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography className="inner_box_head_title">
                General Fee Amount
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                className="inner_box_head_title"
                sx={{ color: "#F0C62E" }}
              >
                Category Discount
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography
                className="inner_box_head_title"
                sx={{ color: "#2789FD" }}
              >
                Final Fee Amount
              </Typography>
            </Grid>
          </Grid>
        )}
        {feeData?.list?.length === 0 && (
          <Typography className="inner_box_notFound">
            No Fee Structure Found
          </Typography>
        )}
        {isMobile
          ? // Mobile Card View
            feeData?.list?.map((item, i) => (
              <Box
                key={i}
                sx={{
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  p: 1.5,
                  mb: 1.5,
                  backgroundColor: "#f9f9f9",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    mb: 1,
                    color: "#0c2f49",
                  }}
                >
                  {item?.feeType}
                </Typography>

                <Stack spacing={0.5}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                      General Fee:
                    </Typography>
                    <Stack direction="row" alignItems="center" gap={0.3}>
                      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
                        {IndianCurrency(item?.generalFeeAmount)}
                      </Typography>
                      <Typography sx={{ fontSize: "12px" }}>
                        x{item?.count} ={" "}
                        {IndianCurrency(
                          Number(item?.count) * Number(item?.generalFeeAmount)
                        )}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                      Discount:
                    </Typography>
                    <Stack direction="row" alignItems="center" gap={0.3}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#F0C62E",
                        }}
                      >
                        {IndianCurrency(item?.categoryDiscountAmount)}
                      </Typography>
                      <Typography sx={{ fontSize: "12px" }}>
                        x{item?.count} ={" "}
                        {IndianCurrency(
                          Number(item?.count) *
                            Number(item?.categoryDiscountAmount)
                        )}
                      </Typography>
                    </Stack>
                  </Stack>

                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                      Final Fee:
                    </Typography>
                    <Stack direction="row" alignItems="center" gap={0.3}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 600,
                          color: "#2789FD",
                        }}
                      >
                        {IndianCurrency(item?.feeAmount)}
                      </Typography>
                      <Typography sx={{ fontSize: "12px" }}>
                        x{item?.count} ={" "}
                        {IndianCurrency(
                          Number(item?.count) * Number(item?.feeAmount)
                        )}
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Box>
            ))
          : // Desktop Table View
            feeData?.list?.map((item, i) => (
              <Grid container sx={{ px: "10px", py: "5px" }} key={i}>
                <Grid item xs={3}>
                  <Typography className="inner_box_head_title">
                    {item?.feeType}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Stack direction={"row"} alignItems={"flex-end"} gap={0.3}>
                    <Typography className="inner_box_head_title">
                      {IndianCurrency(item?.generalFeeAmount)}
                    </Typography>
                    <Typography>
                      x{item?.count} ={" "}
                      <span className="inner_box_head_title">
                        {IndianCurrency(
                          Number(item?.count) * Number(item?.generalFeeAmount)
                        )}
                      </span>
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack direction={"row"} alignItems={"flex-end"} gap={0.3}>
                    <Typography
                      className="inner_box_head_title"
                      sx={{ color: "#F0C62E !important" }}
                    >
                      {IndianCurrency(item?.categoryDiscountAmount)}
                    </Typography>
                    <Typography>
                      x{item?.count} ={" "}
                      <span className="inner_box_head_title">
                        {IndianCurrency(
                          Number(item?.count) *
                            Number(item?.categoryDiscountAmount)
                        )}
                      </span>
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack direction={"row"} alignItems={"flex-end"} gap={0.3}>
                    <Typography
                      className="inner_box_head_title"
                      sx={{ color: "#2789FD !important" }}
                    >
                      {IndianCurrency(item?.feeAmount)}
                    </Typography>

                    <Typography>
                      x{item?.count} ={" "}
                      <span className="inner_box_head_title">
                        {IndianCurrency(
                          Number(item?.count) * Number(item?.feeAmount)
                        )}
                      </span>
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            ))}
      </FeeStructureTableWrapper>
      {feeData?.list?.length > 0 && (
        <Stack
          direction="row"
          alignItems={"center"}
          justifyContent={isMobile ? "center" : "flex-end"}
          sx={{ mt: 2 }}
        >
          <Box
            mr={isMobile ? 0 : 5}
            p={isMobile ? 1 : 0.5}
            sx={{
              border: "1px solid rgba(0,0,0,0.6)",
              display: "inline-block",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <Stack
              direction={isMobile ? "column" : "row"}
              alignItems={isMobile ? "stretch" : "center"}
              justifyContent={"flex-end"}
              gap={isMobile ? 1 : 2}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={isMobile ? "space-between" : "flex-start"}
                gap={1}
              >
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Total Fee Amount:
                </Typography>
                <Typography sx={{ fontSize: "15px", fontWeight: 600 }}>
                  {IndianCurrency(state.totalFee)}
                </Typography>
              </Stack>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={isMobile ? "space-between" : "flex-start"}
                gap={1}
              >
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Total Discount Amount:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#F0C62E",
                  }}
                >
                  {IndianCurrency(state.totalDiscount)}
                </Typography>
              </Stack>
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={isMobile ? "space-between" : "flex-start"}
                gap={1}
              >
                <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                  Final Fee Amount:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 600,
                    color: "#2789FD",
                  }}
                >
                  {IndianCurrency(state.totalFinalFee)}
                </Typography>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default ShowFeeStructure;
